import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tf-text-display',
  standalone: true,
  template: `<span>{{ value() ?? '—' }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextDisplayComponent {
  readonly value = input<unknown>();
}
